import { FunctionComponent } from 'preact';
import cn from 'classnames';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';

import { useOverlayContext } from './OverlayContext';
import { useIcons } from '../../hooks/useIcons';
import { useViewportType } from '../../hooks/useViewportType';

export const CloseButton: FunctionComponent<IconButtonProps> = ({
  className,
  ...props
}) => {
  const { onCloseClick } = useOverlayContext();
  const { Cancel } = useIcons();
  const { isMobile } = useViewportType();

  return (
    <IconButton
      className={cn('vgp-close-button', className)}
      onClick={onCloseClick}
      color="video-ui"
      size={isMobile ? 'small' : 'medium'}
      {...props}
    >
      <Cancel />
    </IconButton>
  );
};
